import smartSolveApi from './instances/smartsolve';

export const getFormsList = async () => {
  try {
    const response = await smartSolveApi.post('/forms/openformlist', {});

    return response.data;
  } catch (e) {
    throw new Error(`getformslist() failed: ${e}`);
  }
};
